import type { ReactNode } from 'react'
import { DashboardPageHeader } from '../DashboardPageHeader'

/** Shared page heading for workspace sections. The legacy bar is reserved for
    controls that function as filters. */
export function SectionBar({ icon, title, subtitle, children, variant = 'header' }: {
  icon?: ReactNode
  title: string
  subtitle?: string
  children?: ReactNode
  variant?: 'header' | 'filter'
}) {
  if (variant === 'header') {
    return (
      <DashboardPageHeader
        title={title}
        subtitle={subtitle ?? ''}
        actions={children}
      />
    )
  }

  return (
    <div className="dash-section-bar">
      <div className="dash-section-bar-title">
        {icon ? <span className="dash-section-bar-icon">{icon}</span> : null}
        <div>
          <strong>{title}</strong>
          {subtitle ? <span>{subtitle}</span> : null}
        </div>
      </div>
      {children ? <div className="dash-section-bar-actions">{children}</div> : null}
    </div>
  )
}
